export const openUrl = (url: string) => {
  // eslint-disable-next-line rulesdir/no-window-open
  const newWin = window.open(url);

  if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
    // eslint-disable-next-line no-alert
    alert('Popups are blocked. Please enable popups in your browser to use this feature.');
  }
};
